<template>
  <div>
    <textarea class="textarea"
              rows="10"
              :placeholder="text"
              :class="resizable ? '' : 'textarea--no-resize'"
              :style="{
                width: width + 'px',
                height: height + 'px'
              }"
              :disabled="disabled"
              v-model="content"
              @input="updateText">
    </textarea>
  </div>
</template>

<script>
  export default {
    name: 'Textarea',
    props: {
      width: Number,
      height: Number,
      disabled: Boolean,
      resizable: Boolean,
      value: String,
      text: String
    },
    data () {
      return {
        content: this.value
      }
    },
    methods: {
      updateText () {
        this.$emit('input', this.content)
      }
    }
  }
</script>s

<style lang="scss" scoped>
  @import '../styling/styling.scss';

  .textarea {
    width: calc(100% - #{rem(30)});
    outline-width: 0;
    @extend %animate;
    font-size: rem(13);
    line-height: rem(20);
    border-radius: rem(2);
    font-family: roboto, sans-serif;
    border-color: $dark-grey-background;
    padding: rem(10) rem(20) rem(10) rem(10);

    &--no-resize { resize: none; }

    &:disabled {
      resize: none;
      cursor: not-allowed;
      background-color: #fff;
      border-color: $medium-grey-background;
    }

    &:focus {
      outline-width: 0;
      @extend %animate;
      border-color: $pending-blue;
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Textarea.vue